import React from 'react';
import {cn} from "../utils/style";

function ButtonLong({type, children, onClick, secondary, className, disabled}) {
    return (
        <button
            onClick={e => {
                e.preventDefault();
                if (onClick) onClick(e);
            }}
            type={type || 'submit'}
            disabled={disabled}
            className={cn(
                "group relative flex w-full justify-center items-center gap-3 px-6 py-4 text-base font-black text-white transition-all duration-300 ease-in-out active:scale-[0.98] focus-visible:outline-none disabled:cursor-not-allowed disabled:transform-none border-0",
                secondary
                    ? "bg-gradient-to-br from-rose-500 to-orange-500 hover:from-rose-600 hover:to-orange-600 shadow-lg shadow-rose-500/20 disabled:from-gray-300 disabled:to-gray-400 disabled:shadow-none"
                    : "bg-gradient-to-br from-[#0b5f82] to-[#0b9cbc] hover:from-[#0b5f82] hover:to-[#0b9cbc] shadow-xl shadow-[#0b9cbc]/20 disabled:from-gray-300 disabled:to-gray-400 disabled:shadow-none",
                "rounded-2xl",
                className
            )}
        >
            {children}
            <div className="absolute inset-0 rounded-2xl bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
        </button>
    );
}

export default ButtonLong;
